import { yup } from "@";

const reqWhen = (provider) =>
  yup.string().when("provider", {
    is: provider,
    then: (s) => s.required("هذا الحقل مطلوب"),
    otherwise: (s) => s.nullable().notRequired(),
  });

export const schema = yup
  .object({
    provider: yup.string().oneOf(["wati", "autorply"]).required(),

    // Wati
    watiApiEndpoint: reqWhen("wati"),
    watiAccessToken: reqWhen("wati"),
    watiTenantId: yup.string().nullable(),

    // Autorply
    autorplyApiKey: reqWhen("autorply"),
    autorplySenderNumber: reqWhen("autorply"),
  })
  .required();

export const defaultValues = {
  provider: "wati",
  watiApiEndpoint: "",
  watiAccessToken: "",
  watiTenantId: "",
  autorplyApiKey: "",
  autorplySenderNumber: "",
};
